module.exports = __webpack_public_path__ + "img/sell.535127e3.png";